import React from "react";
import PropTypes from "prop-types";
import Component from "components/component";

import QuantityCounter from "./quantity-counter";

export default class QuantityConfigurationMobile extends Component {
  static propTypes = {
    quantityCount: PropTypes.number.isRequired,
    increaseQuantity: PropTypes.func.isRequired,
    decreaseQuantity: PropTypes.func.isRequired
  };

  render() {
    const { quantityCount, increaseQuantity, decreaseQuantity } = this.props;

    return (
      <div className="mobile-only">
        <div className="product-options-row option-columns three-columns">
          <div className="product-options-wrapper-mobile">
            <p className="option-name">Quantity</p>

            <QuantityCounter
              quantityCount={quantityCount}
              increaseQuantity={increaseQuantity}
              decreaseQuantity={decreaseQuantity}
            />
          </div>
        </div>
      </div>
    );
  }
}
